<template>
  <van-popup
    class="content"
    v-model:show="showValue"
    round
    :style="{ padding: '64px' }"
    @click-overlay="cancel"
    :transition-appear="true"
  >
    <div @click="cancel" class="popup_close close_center"><span></span></div>
    <div class="title">Perks & Play</div>
    <div class="title top_2">Reward to be Claimed</div>
    <van-grid
      class="promotion-grid"
      v-if="showTop"
      :border="false"
      :column-num="4"
      :square="false"
      :clickable="false"
      :gutter="20"
      :key="promotionsKey"
    >
      <van-grid-item
        v-for="(item, index) in promotions"
        :key="index"
        :style="item.claimed ? 'opacity: 0.6;' : ''"
        @click="onNavigate(item.path)"
      >
        <img :src="item.url" alt="" :class="item.claimed ? '' : 'claimed'" />
        <!-- <div class="select-tag" v-if="item.claimed">
          <i class="bi bi-check-lg"></i>
        </div> -->
        <div :class="`item-name ${item.claimed ? '' : 'claimed-name'}`">{{ item.name }}</div>
      </van-grid-item>
    </van-grid>
    <div
      v-if="superTopBanner.length > 0"
      class="top-banner"
      @click="onClickBanner(superTopBanner[0])"
    >
      <img :src="superTopBanner[0].cover" alt="" />
    </div>
    <div v-else class="top-banner" />
    <div class="bottom-banner">
      <img
        @click="onClickBanner(superLeftBanner[0])"
        v-if="superLeftBanner.length > 0"
        :src="superLeftBanner[0].cover"
        alt=""
      />
      <div v-else style="height: 1rem" />
      <img
        @click="onClickBanner(superRightBanner[0])"
        v-if="superRightBanner.length > 0"
        :src="superRightBanner[0].cover"
        alt=""
      />
      <div v-else style="height: 1rem" />
    </div>
    <div class="more-btn" @click="onNavigate('/promotion')">
      More<i class="bi bi-chevron-right"></i>
    </div>
  </van-popup>
</template>

<script>
import { config } from '@/common/config'
import { useLobbyStore } from '@/stores/lobby'
import { mapActions, mapState } from 'pinia'
import { useUserStore } from '@/stores/user'
import { BUS, POPUP } from '@/event/EventCenter'
import { encodeBase64 } from '@/utils/helper'
import { getLocalStorage, Key } from '@/common/localStorage'
import { useEnvelopeStore } from '@/stores/envelope'
import { getLocale } from '@/locales'
import { checkLuckywheel } from '@/utils/helper'
import { useMillionStore } from '@/stores/million'
import { useCashBackStore } from '@/stores/cashback'

export default {
  name: 'FirstPopup',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    cancel: {
      type: Function,
      default: () => {}
    }
  },
  watch: {
    show(val) {
      this.showValue = val
      if (val) {
        this.loading = 0
        this.showTop = false
        this.checkTopStatus()
      }
    },
    loading(val) {
      if (val >= 4) {
        this.loading = 0
        this.showTop = true
      }
    }
  },
  data() {
    return {
      showValue: false,
      promotionsKey: 0,
      loading: 0,
      showTop: false,
      promotions: [
        {
          url: `${config.resBaseUrl}icon_Cash_Back.png`,
          claimed: true,
          name: 'Cash Back',
          path: '/luckycashback'
        },
        {
          url: `${config.resBaseUrl}icon_Lucky_Wheel.png`,
          claimed: true,
          name: 'Lucky Wheel',
          path: '/luckywheel'
        },
        {
          url: `${config.resBaseUrl}icon_Mega_Million.png`,
          claimed: true,
          name: 'Mega Million',
          path: '/million'
        },
        {
          url: `${config.resBaseUrl}icon_Pocket_Money.png`,
          claimed: true,
          name: 'Pocket Money',
          path: '/envelope'
        }
      ],
      superTopBanner: [],
      superLeftBanner: [],
      superRightBanner: []
    }
  },
  computed: {
    ...mapState(useUserStore, ['balance', 'token', 'isLogin', 'country']),
    ...mapState(useLobbyStore, ['allBanner'])
  },
  mounted() {
    this.showValue = this.show
    this.loading = 0
    this.showTop = false
    this.loadConfig()
    this.checkTopStatus()
  },
  methods: {
    ...mapActions(useLobbyStore, {
      getBannersByPosition: 'getBannersByPosition',
      enterGame: 'enterGame'
    }),
    ...mapActions(useEnvelopeStore, { envelope: 'envelope' }),
    ...mapActions(useMillionStore, { cost: 'cost' }),
    ...mapActions(useCashBackStore, { load: 'load' }),
    loadConfig() {
      this.getBannersByPosition('super-top').then((r) => {
        this.superTopBanner = r || []
      })
      this.getBannersByPosition('super-bottom-left').then((r) => {
        this.superLeftBanner = r || []
      })
      this.getBannersByPosition('super-bottom-right').then((r) => {
        this.superRightBanner = r || []
      })
    },
    checkTopStatus() {
      if (this.isLogin) {
        // Cash Back
        this.load()
          .then((res) => {
            let config = res.pigLoad || []
            if (config.length > 0) {
              this.promotions[0].claimed = false
            } else {
              this.promotions[0].claimed = true
            }
            this.loading++
          })
          .finally(() => {
            this.loading++
          })
        // Lucky Wheel
        checkLuckywheel()
          .then((r) => {
            this.promotions[1].claimed = !r
            this.loading++
          })
          .catch((msg) => {
            console.log('msg', msg)
          })
          .finally(() => {
            this.loading++
          })
        //Mega Million
        this.cost()
          .then((res) => {
            const bigGlobal = res?.BigGlobal?.[2]
            this.promotions[2].claimed = !(bigGlobal?.spinType === 3 && bigGlobal?.rewardVal >= 1)
            this.loading++
          })
          .finally(() => {
            this.loading++
          })
        //Pocket Money
        this.envelope()
          .then((res) => {
            if (res.id > 0 && res.status < 3) {
              //用户身上有红包 直接进入活动页主页
              this.promotions[3].claimed = true
            } else {
              //此时用户身上无红包 自动开启红包动画
              this.promotions[3].claimed = false
            }
            this.loading++
          })
          .finally(() => {
            this.loading++
          })
      }
    },
    onClickBanner(banner) {
      this.cancel()
      if (banner && banner.cmd == 'game') {
        if (this.isLogin) {
          this.enterGame(parseInt(banner.cmdValue)).then((response) => {
            this.$router.push({ name: 'gameView', params: { currentGameUrl: response.url } })
          })
        } else {
          // this.$bus.$emit(BUS.SHOW_POPUP, { from: 'promotion', to: POPUP.LOGIN, show: true })
          this.$router.replace('/')
        }
      } else if (banner && banner.cmd == 'h5') {
        window.location.href = banner.cmdValue
      } else if (banner && banner.cmd == 'deeplink') {
        window.pageHistory = { from: '/promotion', to: `/${banner.cmdValue}` }
        this.$router.replace(`/${banner.cmdValue}`)
      } else if (banner && banner.cmd == 'luckywheel') {
        if (!this.isLogin) {
          this.$router.replace('/')
          this.$bus.$emit(BUS.SHOW_POPUP, { from: 'promotion', to: POPUP.LOGIN, show: true })
          return
        }
        const url = `${banner.cmdValue}?token=${encodeBase64(getLocalStorage(Key.Token))}`
        this.$router.push({ name: 'gameView', params: { currentGameUrl: url } })
      } else if (banner && banner.cmd == 'active') {
        if (banner.cmdValue == 'redenvelope') {
          //  红包活动
          if (this.isLogin) {
            this.envelope().then((res) => {
              if (res.id > 0 && res.status < 3) {
                //用户身上有红包 直接进入活动页主页
                window.location.href = `${window.envelopeUrl}/?active=${getLocalStorage(Key.Token)}&lang=${getLocale()}&cid=hbzz&channel=web`
              } else {
                //此时用户身上无红包 自动开启红包动画
                this.$bus.$emit(BUS.SHOW_ACTIVE_BOX, { hasOpened: false })
              }
            })
          } else {
            //弹出活动页注册弹窗
            this.$bus.$emit(BUS.SHOW_POPUP, { from: 'promation', to: POPUP.REGISTER, show: true })
          }
        }
      }
    },
    luckywheel() {
      // https://game.megalake.games
      if (this.isLogin) {
        const url =
          `${config.selfDevelopedGameDomain}/luckywheel/index.html?token=` +
          encodeBase64(getLocalStorage(Key.Token))
        this.$router.push({ name: 'gameView', params: { currentGameUrl: url } })
      } else {
        this.$bus.$emit(BUS.SHOW_POPUP, { from: 'gridListGame', to: POPUP.LOGIN, show: true })
      }
    },
    onNavigate(path) {
      this.cancel()
      if (path == '/luckywheel') {
        this.luckywheel()
        return
      }
      if (path == '/envelope') {
        // this.$bus.$emit(BUS.SHOW_ACTIVE_BOX, { hasOpened: false })
        this.onClickBanner({ cmd: 'active', cmdValue: 'redenvelope' })
        return
      }
      if (path == '/million') {
        this.$router.replace(path)
        return
      }
      if (path == '/luckycashback') {
        this.$router.replace(path)
        return
      }
      this.$router.replace(path)
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  width: 6.5rem;
  min-height: 7.5rem;
  margin: 0 auto;
  padding: 0 !important;
  overflow: visible !important;
  background: #000000;
  border: solid 0.04rem transparent;
  border-radius: 0.16rem;
  background-color: #000;
  background-image: linear-gradient(#000, #000),
    linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
  background-origin: border-box;
  background-clip: content-box, border-box;
  text-align: center;
  z-index: 100;

  .close_center {
    display: flex !important;
    margin-top: -0.4rem !important;
    justify-content: center;
    align-items: flex-start;
  }

  .popup_close {
    height: 0.6rem;
    width: 0.6rem;
    border-radius: 50%;
    background-color: #000;
    border: solid 4px transparent;
    background-image: linear-gradient(#000, #000),
      linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
    background-origin: border-box;
    background-clip: content-box, border-box;
    text-align: center;
    position: absolute;
    display: block;
    z-index: 2;
    margin-left: 93%;

    span {
      display: inline-block;
      width: 0.4rem;
      height: 0.08rem;
      background-color: #aa884a;
      background-image: linear-gradient(
        130deg,
        #dfc572 0%,
        #916c38 50%,
        #825c2d 50.1%,
        #aa884a 100%
      );
      transform: rotate(45deg);
      margin-top: 0.255rem;
    }

    span::after {
      content: '';
      display: block;
      width: 0.4rem;
      height: 0.08rem;
      background-color: #aa884a;
      background-image: linear-gradient(
        130deg,
        #dfc572 0%,
        #916c38 50%,
        #825c2d 50.1%,
        #aa884a 100%
      );
      transform: rotate(-90deg);
    }
  }

  .title {
    width: auto;
    height: 0.31rem;
    font-family: Droid Sans;
    font-weight: 400;
    font-size: 0.3rem;
    color: #ffddac;
    line-height: 0.32rem;
    margin-top: 0.28rem;
  }

  .top_2 {
    margin-top: 0.2rem;
    color: #fff;
    font-size: 0.24rem;
  }

  .promotion-grid {
    margin-top: 0.2rem;

    img {
      width: 100%;
      height: 100%;
    }
    .claimed {
      box-shadow: 0 0 10px rgba(255, 221, 172, 0.5);
      animation:
        grid-glow 1s ease-in-out infinite alternate,
        shake 0.3s ease-in-out infinite;
    }
    @keyframes grid-glow {
      from {
        box-shadow: 0 0 10px rgba(255, 221, 172, 0.5);
      }
      to {
        box-shadow: 0 0 20px rgba(255, 221, 172, 0.8);
      }
    }
    @keyframes shake {
      0%,
      100% {
        transform: rotate(0deg);
      }
      25% {
        transform: rotate(-2deg);
      }
      75% {
        transform: rotate(2deg);
      }
    }

    .claimed-name {
      text-shadow:
        0 0 5px #ffddac,
        0 0 10px #ffddac;
      animation:
        glow 1.5s ease-in-out infinite alternate,
        shake 0.3s ease-in-out infinite;
    }
    @keyframes glow {
      from {
        text-shadow:
          0 0 5px #ffddac,
          0 0 10px #ffddac;
      }
      to {
        text-shadow:
          0 0 10px #ffddac,
          0 0 20px #ffddac;
      }
    }

    .select-tag {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: 0.35rem;
      bottom: 0;
      background-color: #35d750;
      border-radius: 0.1rem;
      width: 0.51rem;
      height: 0.51rem;
      font-size: 0.51rem;
    }

    .item-name {
      position: absolute;
      width: 0.66rem;
      height: auto;
      font-family: Droid Sans;
      font-weight: 400;
      font-size: 0.24rem;
      color: #ceb45f;
      line-height: auto;
      margin-top: 2rem;
      text-align: center;
      width: 90%;
      height: auto;
      overflow: hidden;
      text-overflow: ellipsis;
      // white-space: nowrap;
    }
  }

  .top-banner {
    font-size: 0.24rem;
    text-align: center;
    color: #ffddac;
    margin: 0.2rem 0;
    padding: 0 5%;
    height: auto;
    width: 90%;
    border-radius: 0.16rem;
    overflow: hidden;
    display: block;
    margin-top: 1.2rem;

    img {
      font-size: 0.24rem;
      text-align: center;
      color: #ffddac;
      width: 100%;
      border-radius: 0.16rem;
    }
  }

  .bottom-banner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 5%;
    height: auto;
    width: 90%;
    margin-top: 0.4rem;

    img {
      width: 49%;
      height: 1rem;
      border-radius: 0.16rem;
    }
  }

  .more-btn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 0.24rem;
    color: #ffddac;
    margin-top: 0.4rem;
    padding: 0.2rem 0.4rem;
    margin: 0 auto;

    i {
      font-size: 0.24rem;
      color: #ffddac;
      margin-left: 0.02rem;
      margin-top: 0.01rem;
    }
  }
}
</style>
